export enum BetaalverzoekErrorType {
    APPLICATION_GENERIC_ERROR = 'application-generic-error',

    // === The Errors below all map to the Generic Error  ===
    // PAYMENT_REQUEST_SERVICE_UNAVAILABLE = 'payment-request-service-unavailable',
    // PAYMENT_REQUEST_OPENED_TOO_MANY_TIMES = 'payment-request-opened-too-many-times',
    // PAYMENT_REQUEST_EXPIRED = 'payment-request-expired',
    // PAYMENT_REQUEST_NOT_FOUND = 'payment-request-not-found',
    PAYMENT_REQUEST_GENERIC_ERROR = 'payment-request-generic-error',

    TRANSACTION_STATUS_IS_FAILED = 'payment-transaction-failed-error',
    TRANSACTION_STATUS_IS_EXPIRED = 'payment-transaction-expired-error',
    TRANSACTION_STATUS_IS_CANCELLED = 'payment-transaction-cancelled-error',
    TRANSACTION_REQUEST_SERVICE_UNAVAILABLE = 'payment-transaction-generic-error',
    TRANSACTION_INCOMING_MONTHLY_AMOUNT_EXCEEDED = 'payment-transaction-incoming-amount-exceeded'
}

export interface ErrorData {
    errorType: BetaalverzoekErrorType;
    showReloadOption: boolean;
}
